module.exports = __webpack_public_path__ + "static/logo.291c87c6.png";